import { render, staticRenderFns } from "./ModifyPortingDate.vue?vue&type=template&id=774c3641&scoped=true&"
import script from "./ModifyPortingDate.vue?vue&type=script&lang=js&"
export * from "./ModifyPortingDate.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPortingDate.vue?vue&type=style&index=0&id=774c3641&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c3641",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
